<terra-welcome-layout>
  <section class="welcome-text">
    Welcome back
  </section>

  <section class="welcome-sub-text">
    Covercy works with investors, businesses and individuals to get funds overseas safely, quickly and for the best rates around.
  </section>

  <section class="form-content">

    <ng-container *ngIf="{logoData: referrerLogo$ | async} as referrer">
      <img class="referrer-logo" *ngIf="referrer?.logoData?.showLogo" [src]="referrer?.logoData?.logoUrl"/>
    </ng-container>
    
    <h1>Update password</h1>

    <p *ngIf="!passwordFormGroupSubmitted">
      Please set a new password for your account
    </p>

    <div [formGroup]="passwordFormGroup" class="form terra-error-style" fxLayout="column" fxLayoutGap="1em">
      <mat-form-field appearance="outline" class="input-width" *ngIf="!passwordFormGroupSubmitted">
        <input type="password" matInput placeholder="New password" formControlName="password" maxlength="16"/>
        <mat-error *ngIf="passwordFormGroup.get('password').hasError('required'); else formatErrors">
          Password is required
        </mat-error>
        <ng-template #formatErrors>
          <mat-error *ngIf="passwordFormGroup.get('password').hasError('minlength')">
            Password should be at least 8 characters long
          </mat-error>
          <mat-error *ngIf="passwordFormGroup.get('password').hasError('passwordstrength') && !passwordFormGroup.get('password').hasError('minlength')">
            Password should contain at least one letter and one digit
          </mat-error>
          <!--          &lt;!&ndash; Both format errors &ndash;&gt;-->
          <!--          <mat-error *ngIf="passwordFormGroup.get('password').hasError('minlength') && passwordFormGroup.get('password').hasError('passwordstrength')">-->
          <!--            Password should be at least 8 characters and contain at least one letter and one digit-->
          <!--          </mat-error>-->
        </ng-template>
      </mat-form-field>

      <mat-form-field appearance="outline" class="input-width" *ngIf="!passwordFormGroupSubmitted">
        <input type="password" matInput placeholder="Confirm new password" formControlName="confirmPassword" required maxlength="40"/>
        <!-- Show only 1 error -->
        <mat-error *ngIf="passwordFormGroup.get('confirmPassword').hasError('required'); else confirmErrors">
          Password is required
        </mat-error>
        <ng-template #confirmErrors>
          <mat-error *ngIf="passwordFormGroup.get('confirmPassword').hasError('matchPassword')">
            Password doesn't match
          </mat-error>
        </ng-template>
      </mat-form-field>

      <div class="login-button-container" class="input-width" *ngIf="!passwordFormGroupSubmitted">
        <button class="button" (click)="resetPassword()" mat-flat-button color="primary" [disabled]="isLoading">Update password</button>

        <p class="goto-register" *ngIf="!passwordFormGroupSubmitted">
          Don’t have an account yet?
          <a [routerLink]="routingService.signupUrlBySubdomain" queryParamsHandling="preserve" routerLinkActive="active">Sign up</a>
        </p>
      </div>
      <div class="authorized-uk" *ngIf="!passwordFormGroupSubmitted">
        <mat-icon class="notranslate">verified_user</mat-icon>
        Authorised by the UK FCA
      </div>

      <p *ngIf="passwordFormGroupSubmitted" class="padding-top-30">
        Your password has been updated,
        <a [routerLink]="routingService.loginUrlBySubdomain" queryParamsHandling="preserve" routerLinkActive="active">log in</a> to get started
      </p>

      <p *ngIf="generalError" class="error-message">{{generalError}}
        Get a new one <a [routerLink]="paths.FORGOT_PASSWORD" routerLinkActive="active">here</a>
      </p>
    </div>
  </section>
</terra-welcome-layout>
